// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__KkQOg","inner":"Form_inner__SmZzJ","range":"Form_range__350cT","name":"Form_name__2A9_B","actions":"Form_actions__Uxnd-"};